import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="navbar"
export default class extends Controller {
  static targets = ["mobileMenu", "menuIcon"];

  connect() {
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
  }

  disconnect() {
    window.removeEventListener("click", this.handleOutsideClick);
  }

  toggleMenu() {
    const isOpen = !this.mobileMenuTarget.classList.contains("hidden");
    isOpen ? this.close() : this.open();
  }

  open() {
    this.mobileMenuTarget.classList.remove("hidden");
    this.menuIconTarget.classList.replace("fa-bars", "fa-xmark");
    setTimeout(
      () => window.addEventListener("click", this.handleOutsideClick),
      0,
    );
  }

  close() {
    this.mobileMenuTarget.classList.add("hidden");
    this.menuIconTarget.classList.replace("fa-xmark", "fa-bars");
    window.removeEventListener("click", this.handleOutsideClick);
  }

  handleOutsideClick(event) {
    if (!this.element.contains(event.target)) {
      this.close();
    }
  }
}
